"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DEFAULT_TOKEN_LIFETIME_SECONDS = 900;
var TOKEN_FIELD_RETRY_MS = 1000;
function readTokensFromQuery() {
  var urlParams = new URLSearchParams(window.location.search);
  var authToken = urlParams.get("data");
  var refreshToken = urlParams.get("ici_refreshtoken");
  var ttl = urlParams.get("ici_accesstokenTTL");
  if (!authToken || !refreshToken) return null;
  return {
    authToken: authToken,
    refreshToken: refreshToken,
    expiresIn: ttl ? parseInt(ttl, 10) : DEFAULT_TOKEN_LIFETIME_SECONDS
  };
}
function readTokensFromHiddenFields() {
  var authTokenInput = document.getElementById("UserApiToken");
  var refreshTokenInput = document.getElementById("RefreshApiToken");
  var ttlInput = document.getElementById("AccessTokenTTLInSec");
  if (!(authTokenInput !== null && authTokenInput !== void 0 && authTokenInput.value) || !(refreshTokenInput !== null && refreshTokenInput !== void 0 && refreshTokenInput.value)) return null;
  return {
    authToken: authTokenInput.value,
    refreshToken: refreshTokenInput.value,
    expiresIn: ttlInput !== null && ttlInput !== void 0 && ttlInput.value ? parseInt(ttlInput.value, 10) : DEFAULT_TOKEN_LIFETIME_SECONDS
  };
}
function postToParent(payload) {
  Office.onReady(function () {
    var _Office$context$ui;
    if ((_Office$context$ui = Office.context.ui) !== null && _Office$context$ui !== void 0 && _Office$context$ui.messageParent) {
      Office.context.ui.messageParent(JSON.stringify(payload));
    }
  });
}
var IcertisCallbackPage = function IcertisCallbackPage() {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    failed = _useState2[0],
    setFailed = _useState2[1];
  (0, _react.useEffect)(function () {
    var sendTokensToParent = function sendTokensToParent() {
      try {
        var _readTokensFromQuery;
        var tokens = (_readTokensFromQuery = readTokensFromQuery()) !== null && _readTokensFromQuery !== void 0 ? _readTokensFromQuery : readTokensFromHiddenFields();
        if (!tokens) return false;
        postToParent(tokens);
        return true;
      } catch (error) {
        console.error("Error sending tokens to parent:", error);
        postToParent({
          error: "Failed to extract authentication tokens",
          details: error instanceof Error ? error.message : String(error)
        });
        return true;
      }
    };
    if (sendTokensToParent()) return;
    var timeout = setTimeout(function () {
      if (sendTokensToParent()) return;
      setFailed(true);
      postToParent({
        error: "Icertis finished sign-in without returning tokens to the add-in."
      });
    }, TOKEN_FIELD_RETRY_MS);
    return function () {
      clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      flexDirection: "column"
    },
    "data-sentry-component": "IcertisCallbackPage",
    "data-sentry-source-file": "IcertisCallbackPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: {
        fontSize: "18px",
        fontWeight: 500,
        marginTop: "16px"
      },
      children: failed ? "Sign-in did not complete" : "Authentication successful!"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: {
        fontSize: "14px",
        color: "#666",
        marginTop: "8px"
      },
      children: failed ? "Icertis did not return sign-in details. Close this window and try again." : "You can close this window."
    })]
  });
};
var _default = exports.default = IcertisCallbackPage;